import React from "react";

const ComplaintForm = ({ formData, handleChange }) => {
    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                <div className="accordion" id="complaintAccordion">
                    {/* Section 1: Complaint Details */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#complaintDetails">
                                1. Complaint Details
                            </button>
                        </h2>
                        <div id="complaintDetails" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="dateOfComplaint" value={formData.dateOfComplaint || ""} onChange={handleChange} />
                                            <label>Date of Complaint</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-4">
                                        Department/Area of Concern
                                    </small>
                                    <div className="row g-2">
                                        <div className="col-md-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="department" id="administration" value="Administration" checked={formData.department === "Administration"} onChange={handleChange} />
                                                <label className="form-check-label" htmlFor="administration">Administration</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="department" id="kitchen" value="Kitchen" checked={formData.department === "Kitchen"} onChange={handleChange} />
                                                <label className="form-check-label" htmlFor="kitchen">Kitchen</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="department" id="housekeeping" value="Housekeeping" checked={formData.department === "Housekeeping"} onChange={handleChange} />
                                                <label className="form-check-label" htmlFor="housekeeping">Housekeeping</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="department" id="nursingPrp" value="Nursing/PRP" checked={formData.department === "Nursing/PRP"} onChange={handleChange} />
                                                <label className="form-check-label" htmlFor="nursingPrp">Nursing/PRP</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4 d-flex align-items-center">
                                            <div className="form-check me-2">
                                                <input className="form-check-input" type="radio" name="department" id="other" value="Other" checked={formData.department === "Other"} onChange={handleChange} />
                                                <label className="form-check-label" htmlFor="other">Other</label>
                                            </div>
                                            {formData.department === "Other" && (
                                                <input type="text" className="form-control" name="otherDepartment" value={formData.otherDepartment || ""} onChange={handleChange} placeholder="Please specify" />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row g-3 mt-3">
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <textarea className="form-control" name="complaintDescription" value={formData.complaintDescription || ""} onChange={handleChange} rows="4" />
                                            <label>Complaint Description</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <textarea className="form-control" name="suggestedSolution" value={formData.suggestedSolution || ""} onChange={handleChange} rows="4" />
                                            <label>Suggested Solution (if any)</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 2: Resolution Details */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#resolutionDetails">
                                2. Resolution Details (For Admin Department Use)
                            </button>
                        </h2>
                        <div id="resolutionDetails" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <div className="form-floating form-floating-outline">
                                            <textarea className="form-control" name="resolutionSummary" value={formData.resolutionSummary || ""} onChange={handleChange} rows="6" />
                                            <label>Resolution Summary</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="dateOfResolution" value={formData.dateOfResolution || ""} onChange={handleChange} />
                                            <label>Date of Resolution</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: Complaint Acknowledgment */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#complaintAcknowledgment">
                                3. Complaint Acknowledgment
                            </button>
                        </h2>
                        <div id="complaintAcknowledgment" className="accordion-collapse collapse">
                            <div className="accordion-body">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-4">
                                    Nursing/PRP Staff Acknowledgment (Post-Resolution)
                                </small>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="resolvedBy" value={formData.resolvedBy || ""} onChange={handleChange} />
                                            <label>Complaint resolved by</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="staffDateOfResolution" value={formData.staffDateOfResolution || ""} onChange={handleChange} />
                                            <label>Date of resolution</label>
                                        </div>
                                    </div>
                                </div>
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-4">
                                    Admin Department
                                </small>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="adminRepresentative" value={formData.adminRepresentative || ""} onChange={handleChange} />
                                            <label>Admin Department Representative</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="adminDate" value={formData.adminDate || ""} onChange={handleChange} />
                                            <label>Date</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ComplaintForm;